const APP_URL = 'https://app.theonestack.com';
const AMS_PATH = '/ams';

const footerLinks = [
  {
    heading: 'Product',
    links: [
      { label: 'Features', href: '#features' },
      { label: 'Verticals', href: '#verticals' },
      { label: 'How It Works', href: '#how-it-works' },
      { label: 'Pricing', href: '#pricing' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'The One Stack', href: 'https://theonestack.com' },
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Service', href: '/terms' },
    ],
  },
  {
    heading: 'Support',
    links: [
      { label: 'Documentation', href: '#' },
      { label: 'Contact Us', href: '#' },
      { label: 'System Status', href: '#' },
      { label: 'Sign In', href: `${APP_URL}${AMS_PATH}` },
    ],
  },
];

export function Footer() {
  return (
    <footer className="border-t border-ams-800/30 bg-[#060a08]">
      <div className="mx-auto max-w-6xl px-6 py-16">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div>
            <div className="mb-4 flex items-center gap-2.5">
              <AmsIconSmall />
              <span className="font-semibold tracking-tight">TheOne AMS</span>
            </div>
            <p className="text-sm text-zinc-500 leading-relaxed">
              The complete association management platform for HOAs, chambers of commerce, and advocacy organizations. Part of The One Stack.
            </p>
          </div>

          {/* Link columns */}
          {footerLinks.map((col) => (
            <div key={col.heading}>
              <h4 className="mb-4 text-sm font-semibold text-zinc-300">{col.heading}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-zinc-500 transition hover:text-zinc-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-ams-800/20 pt-8 sm:flex-row">
          <p className="text-xs text-zinc-600">
            &copy; 2026 The One Stack. All rights reserved.
          </p>
          <p className="text-xs text-zinc-600">
            Part of The One Stack ecosystem
          </p>
        </div>
      </div>
    </footer>
  );
}

function AmsIconSmall() {
  return (
    <svg width="22" height="22" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="6" fill="#042f2e" />
      <path
        d="M8 24V14L16 8L24 14V24"
        stroke="url(#footer-ams-grad)"
        strokeWidth="1.5"
        strokeLinejoin="round"
        fill="none"
      />
      <circle cx="16" cy="17" r="3.5" stroke="#2dd4bf" strokeWidth="1.5" fill="none" />
      <path d="M16 13.5V10" stroke="#2dd4bf" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M12 24V20H20V24"
        stroke="url(#footer-ams-grad)"
        strokeWidth="1.5"
        strokeLinejoin="round"
        fill="none"
      />
      <defs>
        <linearGradient id="footer-ams-grad" x1="8" y1="8" x2="24" y2="24" gradientUnits="userSpaceOnUse">
          <stop stopColor="#5eead4" />
          <stop offset="1" stopColor="#0d9488" />
        </linearGradient>
      </defs>
    </svg>
  );
}
